const tubeGalvanise = [
  {
    id: "tube-carre-galva",
    title: "Tube carré galva",
    image: "/assets/images/products/tube carree galva.webp",
    specImage: null,
    description: "Tubes en acier galvanisé de section carrée pour structures et constructions",
    longDescription: "Disponibles en différentes épaisseurs de 0.7mm à 8mm, les tubes carrés galvanisés offrent une excellente résistance à la corrosion.",
    category: "tube_galvanise",
    specifications: [
      "Dimensions: de 10x10mm à 300x300mm",
      "Épaisseur: de 1mm à 8mm selon dimensions",
      "Acier S235JRH ou S355J2H",
      "Finition: galvanisée",
      "Longueur standard: 6m",
      "Protection anticorrosion"
    ]
  },
  {
    id: "tube-rectangulaire-galva",
    title: "Tube rectangulaire",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbuBnrtLz1rSdYb6EIZfJi2BARjBaAaQ3kSw&s",
    specImage: null,
    description: "Tubes en acier galvanisé de section rectangulaire pour structures optimisées",
    longDescription: "Disponibles en différentes épaisseurs de 0.7mm à 6mm, ces tubes rectangulaires galvanisés sont idéals pour les structures extérieures.",
    category: "tube_galvanise",
    specifications: [
      "Dimensions: de 20x10mm à 400x200mm",
      "Épaisseur: de 1mm à 8mm selon dimensions",
      "Acier S235JRH ou S355J2H",
      "Finition: galvanisée",
      "Longueur standard: 6m",
      "Haute résistance à la corrosion"
    ]
  }
];

export default tubeGalvanise;
